module.exports = __webpack_public_path__ + "static/media/4.434bc88a.png";